export const filterItemStyle = () => {
  return {
    outer: 'block pt-1 ml-6',
    checkbox: '-ml-6',
    label: 'inline text-base pl-2',
  };
};
